import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CategoryFavoriteService } from '../service/category-favorite.service';
import * as CategoryFavoriteActions from './category-favorite.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class CategoryFavoriteEffects {
  private actions$ = inject(Actions);
  private categoryFavoriteService = inject(CategoryFavoriteService);

  getCategoryFavorites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryFavoriteActions.loadCategoryFavorites),
      switchMap(({ language }) => {
        return this.categoryFavoriteService.getCategoryFavorites(language).pipe(
          map((categoryFavorites) => CategoryFavoriteActions.loadCategoryFavoritesSuccess({ categoryFavorites })),
          catchError((error) => of(CategoryFavoriteActions.loadCategoryFavoritesFailure({ error })))
        );
      })
    )
  );

  setCategoryFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryFavoriteActions.setCategoryFavorite),
      switchMap(({ id }) =>
        this.categoryFavoriteService.setCategoryFavoriteForId(id).pipe(
          map((response) => CategoryFavoriteActions.setCategoryFavoriteSuccess({ response })),
          catchError((error) => of(CategoryFavoriteActions.setCategoryFavoriteFailure({ error })))
        )
      )
    )
  );

  deleteCategoryFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryFavoriteActions.deleteCategoryFavorite),
      switchMap(({ id }) =>
        this.categoryFavoriteService.deleteCategoryFavoriteForId(id).pipe(
          map((response) => CategoryFavoriteActions.deleteCategoryFavoriteSuccess({ response })),
          catchError((error) => of(CategoryFavoriteActions.deleteCategoryFavoriteFailure({ error })))
        )
      )
    )
  );

  reloadAfterSetFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryFavoriteActions.setCategoryFavoriteSuccess),
      map(() =>
        CategoryFavoriteActions.loadCategoryFavorites({ language: localStorage.getItem('userUiLanguage') ?? '' })
      )
    )
  );

  reloadAfterDeleteFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryFavoriteActions.deleteCategoryFavoriteSuccess),
      map(() =>
        CategoryFavoriteActions.loadCategoryFavorites({ language: localStorage.getItem('userUiLanguage') ?? '' })
      )
    )
  );
}
